import React, {
  useState,
  useEffect,
  useCallback,
  forwardRef,
  useImperativeHandle,
} from "react";
import useAppContext, { actions } from "../../../utils/Reducers";
import { useAxiosWithAuthorization } from "../../../utils/api";
import { ModalImcomingPop } from "../popup/ImcomingPop";
import moment from "moment";

const WeightInfo = forwardRef((props, ref) => {
  useImperativeHandle(ref, () => ({
    async onSearch(item) {
      await handleMasterSearch(item);
    },
  }));

  const [searchData, setSearchData] = useState([]);

  const [statusW, setStatusW] = useState("");

  const {
    store: { userInfo },
  } = useAppContext();

  const SEARCH_IMPORTSCRAPDAILY_LIST_URL =
    "/mobileweb/outgoing/SP_SEARCH_IMPORT_LIST.do";

  const [, fetchData] = useAxiosWithAuthorization(
    {
      url: SEARCH_IMPORTSCRAPDAILY_LIST_URL,
    },
    { manual: true }
  );

  useEffect(async () => {
    await handleMasterSearch(props.searchParameters);
  }, []);

  const handleMasterSearch = async (item) => {
    console.log(item);
    const {
      data: { data },
    } = await fetchData({
      url: SEARCH_IMPORTSCRAPDAILY_LIST_URL,
      params: {
        schPlantCd: item.schPlantCd,
        schSearch: item.schSearch,
        schTransStatusCd: "",
        schSwghtDt: moment().format("YYYY-MM-DD"),
        schEwghtDt: moment().format("YYYY-MM-DD"),
      },
    });
    setSearchData(data);
    setStatusW(data.length);
  };

  const onGradeConfirm = (data) => {
    ModalImcomingPop({
      importData: data,
      onClose: onClose,
    });
  };

  //팝업 데이터 가져오기
  const onClose = useCallback(async () => {
    handleMasterSearch(props.searchParameters);
  });

  return (
    <>
      <div id="menu2" className="list">
        {searchData &&
          searchData?.map((data, index) => {
            return (
              <div key={index} onClick={(event) => onGradeConfirm(data)}>
                <div className="ctitle">
                  <h1 className="carno">{data.vhclNo}</h1>
                  <div>
                    {data.cameraCnt > 0 ? (
                      <button className="camera"></button>
                    ) : (
                      ""
                    )}
                    {data.warmCnt > 0 ? <button className="al"></button> : ""}
                    {data.outageWght > 0 ? (
                      <div className="nums">-{data.outageWght}</div>
                    ) : (
                      ""
                    )}
                    {data.returnCnt > 0 ? (
                      <button className="close"></button>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className="cinfo">
                  <div>
                    <h2>
                      {data.itemNm}
                      {data.inspRmks !== null ? "(" + data.inspRmks + ")" : ""}
                    </h2>
                  </div>
                  <div className="no">
                    <h2>{data.wssId}</h2>
                  </div>
                  <div>
                    <div className="stat calling">입차중량</div>
                    <div>
                      <h2 className="date arrive" style={{ marginLeft: "0" }}>
                        {data.inWeight}kg
                      </h2>
                    </div>
                  </div>
                </div>
                <div className="cinfo">
                  <div>
                    <h2>{data.scrapAreaCdNm}</h2>
                  </div>
                  <div className="phone">
                    <h2>{data.drivTel}</h2>
                  </div>
                  <div>
                    <div className="stat arrive">입차</div>
                    <div>
                      <h2 className="date arrive" style={{ marginLeft: "0" }}>
                        {data.inptDt}
                      </h2>
                    </div>
                  </div>
                  <div className="com">
                    <h2>{data.vndrNm}</h2>
                  </div>
                </div>
              </div>
            );
          })}
      </div>
      {searchData?.length > 0 ? (
        <div className="res">
          <div>
            <div>계근정보</div>
            <div className="val">
              <div>{statusW}</div>
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
});

export default WeightInfo;
